<template>
  <div class="OHowPeopleUseLifferySolo pl-4 pr-4" :class="{woman: type === 'woman', man: type === 'man'}">
    <div class="person">
      <div class="face" :class="{woman: type === 'woman', man: type === 'man'}">
        <img v-if="type === 'woman'"
             src="@/assets/landing-pages/forPeople/2023/face-woman-glasses.svg"
             alt="Liffery fan"
        />
        <img v-else
             src="@/assets/landing-pages/forPeople/2023/face-man-beard.svg"
             alt="Liffery fan"
        />
      </div>

      <div
        v-if="type === 'woman'"
        class="description content"
      >
        <h2>
          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferySolo.j9.title') }}
        </h2>

        <p v-if="isIos">
          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferySolo.j9.textIos') }}
        </p>
        <p v-else class="highlightLinks" v-html="$tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferySolo.j9.text')"/>
        <p>
          <router-link :to="{name: routeNames.ROUTE_DASHBOARD}" v-if="getIsAuthenticated">
            <b-button>
              {{ $t('page.whatIsLiffery.new2023.loggedIn') }}
            </b-button>
          </router-link>
          <b-button
            v-else
            @click="loginPrompt(EnumRegisteredFromAction.ctaPriceWatch)">
            {{ $tc('page.whatIsLiffery.new2023.tryItOut') }}
          </b-button>
        </p>
      </div>

      <div
        v-else
        class="description content"
      >
        <h2>
          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferySolo.john.title') }}
        </h2>
        <p v-if="isIos">
          {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferySolo.john.textIos') }}
        </p>
        <p v-else class="highlightLinks" v-html="$tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferySolo.john.text')"/>
        <p>
          <router-link :to="{name: routeNames.ROUTE_DASHBOARD}" v-if="getIsAuthenticated">
            <b-button>
              {{ $t('page.whatIsLiffery.new2023.loggedIn') }}
            </b-button>
          </router-link>
          <b-button
            v-else
            @click="loginPrompt">
            {{ $tc('page.whatIsLiffery.new2023.tryItOut') }}
          </b-button>
        </p>
      </div>
    </div>

    <div>
      <img
        v-if="type === 'woman'"
        src="@/assets/landing-pages/forPeople/2023/price-watch.png"
        srcset="@/assets/landing-pages/forPeople/2023/price-watch.png 1x,
                  @/assets/landing-pages/forPeople/2023/price-watch2x.png 2x"
        alt="Liffery price watcher">
      <img
        v-else
        src="@/assets/landing-pages/forPeople/2023/price-watch-speaker.png"
        srcset="@/assets/landing-pages/forPeople/2023/price-watch-speaker.png 1x,
                  @/assets/landing-pages/forPeople/2023/price-watch-speaker2x.png 2x"
        alt="Liffery price watcher">
    </div>
  </div>
</template>

<style scoped lang="scss">
.highlightLinks {
  ::v-deep a {
    color: white !important;
  }
}

.OHowPeopleUseLifferySolo {
  background-color: #8ed2db;
  padding-top: 5rem;
  padding-bottom: 5rem;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4rem;

  .person {
    display: flex;
    align-items: center;
    gap: 4rem;

    .description {
      width: 250px;
    }
  }

  @media screen and (max-width: $widescreen) {
    flex-direction: column;

    .person {
      flex-direction: column;
      gap: 2rem;

      .face {
        margin-right: 8rem;

        &.man {
          margin-right: -8rem;
        }
      }

      .description {
        width: unset;
        text-align: center;
      }
    }
  }
}

</style>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AuthenticationStore } from '@/store';
import { RouteNames } from '@/router/RouteNames';
import isIosApp from '@/utils/isIosApp';
import { EnumRegisteredFromAction } from '@/store/modules/interfaces/AuthenticationModule';

@Component
export default class OHowPeopleUseLifferySoloWoman extends Vue {
  @Prop({ required: true })
  type!: 'man' | 'woman';

  routeNames = RouteNames;

  isIos = isIosApp();

  get getIsAuthenticated () {
    return AuthenticationStore.getAuthenticated;
  }

  loginPrompt (registeredFromAction: EnumRegisteredFromAction) {
    AuthenticationStore.TOGGLE_PROMPT_LOGIN({ state: true, metaData: { registeredFromAction } });
  }
}
</script>
